module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_mgbt-16px _fs-3 _tal-ct _tal-l-sm"
  }, [_c('strong', [_vm._v("วิธีติดตั้ง Biomatic")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdrd-2px _pdh-16px _pdv-16px"
  }, [_c('p', {
    staticClass: "_mgbt-16px _fs-5 _mgt-8px"
  }, [_c('strong', [_vm._v("วิธีที่หนึ่ง – ")]), _vm._v(" "), _c('a', {
    staticClass: "bio-link -fancy",
    attrs: {
      "href": "https://github.com/BioMaRu/biomatic/releases/download/v0.1.4/biomatic.full.min.css.zip"
    }
  }, [_vm._v("ดาวน์โหลด CSS")]), _vm._v(" และลิงค์ไปยัง Project ของของคุณด้วย")]), _vm._v(" "), _c('pre', {
    staticClass: "_mgbt-32px"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<link href=\"/path/to/biomatic.css\" rel=\"stylesheet\">")])]), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("วิธีที่สอง – ")]), _vm._v(" ติดตั้งผ่าน npm หรือ yarn")]), _vm._v(" "), _c('pre', {
    staticClass: "_mgbt-8px"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("npm install biomatic")])]), _vm._v(" "), _c('pre', {
    staticClass: "_mgbt-8px"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("yarn add biomatic")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-199fc4da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/home/HomeGettingStartSetup.vue
// module id = 115
// module chunks = 0